import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import NewPush from './pages/NewPush';
import ViewPush from './pages/ViewPush';
import Dashboard from './pages/Dashboard';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import PushCreated from './pages/PushCreated';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import AccountBrand from './pages/AccountBrand';
import AccountSubscription from './pages/AccountSubscription';
import AccountDomain from './pages/AccountDomain';
import BrandLanding from './pages/BrandLanding';
import AdminDashboard from './pages/AdminDashboard';
import AdminUsers from './pages/AdminUsers';
import AdminBrands from './pages/AdminBrands';
import AdminSettings from './pages/AdminSettings';
import Header from './components/Header';
import Footer from './components/Footer';
import BrandHeader from './components/BrandHeader';
import BrandFooter from './components/BrandFooter';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import { BrandProvider, useBrand } from './context/BrandContext';

function Layout({ children }) {
  const { isBranded, mode } = useBrand();
  const location = useLocation();

  // Hide global Tecnologie chrome when we are on a branded route/host
  const useBrandChrome = isBranded && (mode === 'branded-path' || mode === 'branded-host');

  return (
    <div className="App min-h-screen flex flex-col">
      {useBrandChrome ? <BrandHeader /> : <Header />}
      <main className="flex-1">{children}</main>
      {useBrandChrome ? <BrandFooter /> : <Footer />}
    </div>
  );
}

// When on a custom-domain / branded host, root '/' should render the branded landing
function BrandedRoot() {
  const { brand, loading } = useBrand();
  if (loading) return null;
  if (brand) return <BrandLanding embeddedBrand={brand} />;
  return <Home />;
}

function BrandedNewPush() {
  return <NewPush />;
}

function BrandedViewPush() {
  return <ViewPush />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <BrandProvider>
          <Layout>
            <Routes>
              {/* Root: renders Home OR branded landing if we're on a custom domain */}
              <Route path="/" element={<BrandedRoot />} />

              {/* Push routes (also used on custom domains) */}
              <Route path="/p/new" element={<BrandedNewPush />} />
              <Route path="/p/created/:token" element={<PushCreated />} />
              <Route path="/p/:token" element={<BrandedViewPush />} />

              {/* Platform-only pages */}
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/features" element={<Features />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/account/brand" element={<AccountBrand />} />
              <Route path="/account/subscription" element={<AccountSubscription />} />
              <Route path="/account/domain" element={<AccountDomain />} />

              {/* Admin */}
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/brands" element={<AdminBrands />} />
              <Route path="/admin/settings" element={<AdminSettings />} />

              {/* Explicit branded routes (path-based) */}
              <Route path="/b/:slug" element={<BrandLanding />} />
              <Route path="/b/:slug/p/new" element={<NewPush />} />
              <Route path="/b/:slug/p/created/:token" element={<PushCreated />} />
              <Route path="/b/:slug/p/:token" element={<ViewPush />} />
            </Routes>
          </Layout>
          <Toaster richColors position="top-right" />
        </BrandProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
